import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import {
    selectRecipientInfo,
    selectSellerName,
    selectShowCountryFlag,
    useStaticContext
} from '../../context/contexts/static';
import CountryFlag from '../CountryFlag';

import mainClasses from '../ContactSellerPopUp/ContactSellerDrawer/style.module.scss';

export const MessageSeller = ({ className, compactView = false }) => {
    const context = useStaticContext();
    const { countryCode } = selectRecipientInfo(context);
    const showCountryFlag = selectShowCountryFlag(context);
    const sellerName = selectSellerName(context);

    return (
        <div className={classNames(className, 'flex', 'flex-items-center', 'co-grey-1100', 'text-bold', 'tbody-4')}>
            <p data-testid="username" className={mainClasses.sellarName}>
                {compactView ? sellerName : <I18n k="send_message.message_seller" params={{ sellerName }}/>}
            </p>
            {showCountryFlag && !compactView && (
                <div className="m-l-8">
                    <CountryFlag countryCode={countryCode}/>
                </div>
            )}
        </div>
    );
};

MessageSeller.propTypes = {
    className: PropTypes.string,
    compactView: PropTypes.bool
};
